import { render, staticRenderFns } from "./DetailView.vue?vue&type=template&id=658c6093&"
import script from "./DetailView.vue?vue&type=script&lang=ts&"
export * from "./DetailView.vue?vue&type=script&lang=ts&"
import style0 from "./DetailView.vue?vue&type=style&index=0&id=658c6093&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports